var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,15.7c-0.3,0-0.5-0.1-0.7-0.3L4,11.2c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.4,3.4l6.8-7.6c0.4-0.4,1-0.4,1.4-0.1s0.4,1,0.1,1.4l-7.5,8.3C9.4,15.5,9.1,15.7,8.8,15.7C8.9,15.7,8.8,15.7,8.8,15.7z",
    fill: "#8E97A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ebec4c9a8e26d291197dc7cbcea0cd8a.svg";
export { ForwardRef as ReactComponent };